import { jsx as _jsx } from "react/jsx-runtime";
import { icons as iconsLucide } from "lucide-react";
import { memo } from "react";
import { tv } from "tailwind-variants";
import parseCamelCaseToKebabCase from "../utils/camelCaseToKebab";
import cn from "../utils/cn";
import kebabToCamelCase from "../utils/kebabToCamelCase";
import cobliIconNames from "./icons-custom-static";
const iconVariants = tv({
    base: "",
    variants: {
        color: {
            primary: "text-primary",
            secondary: "text-secondary",
            success: "text-success",
            danger: "text-danger",
            warning: "text-warning",
            white: "text-white",
            black: "text-black",
            gray: "text-gray",
            "gray-light": "text-gray-light",
            "gray-dark": "text-gray-dark",
        },
        size: {
            xs: "!size-3",
            sm: "!size-4",
            md: "!size-5",
            lg: "!size-8",
            xl: "!size-12",
            "2xl": "!size-16",
            "4xl": "!size-24",
        },
    },
    defaultVariants: {
        size: "sm",
    },
});
export const iconNames = [...Object.keys(iconsLucide).map(parseCamelCaseToKebabCase), ...Object.keys(cobliIconNames)];
const Icon = ({ name, size, color, className, absoluteStrokeWidth }) => {
    const LucideIcon = iconsLucide[kebabToCamelCase(name)];
    if (LucideIcon) {
        return _jsx(LucideIcon, { "data-testid": `lucide-${name}`, absoluteStrokeWidth: absoluteStrokeWidth, className: cn(iconVariants({ size, color }), className) });
    }
    const CustomIcon = cobliIconNames[name];
    if (CustomIcon) {
        return _jsx(CustomIcon, { className: cn(iconVariants({ size, color }), className) });
    }
    console.error(`Icon "${name}" not found`);
    return _jsx("div", { "data-testid": "icon-fallback", className: cn(iconVariants({ size }), "bg-transparent", className) });
};
Icon.displayName = "Icon";
export default memo(Icon);
